<template>
	<section>
        <modal-confirm 
            :title="modalConfirm.title"
            :message="modalConfirm.message"
            type="is-danger"
            has-icon
            confirm-text="YES"
            cancel-text="NO"
            :on-confirm="modalConfirm.onConfirm"
            :on-cancel="modalConfirm.onCancel"
            @close="onModalConfirmClose"
            ref="modalConfirm"
        />
		<b-field grouped group-multiline>
            <div class="control" style="display:flex;">
            	<b-select placeholder="Select Role" style="min-width:200px;" expanded v-model="selectedRole">
                	<option :value="option" v-for="(option, key) in roleDropdown">{{ option.name.toUpperCase() + (systemRole(option) ? ' - SYSTEM ' : '') }} </option>
            	</b-select>
            	<b-button style="width:100px; margin-left:5px;" @click="selectedRole = null, checkedRows = []">Reset</b-button>
                <template v-if="canCreateRole">
                    <b-button type="is-info" style="width:100px; margin-left:5px;" @click="openModel = true, cloneRole = false">Create</b-button>
                	<b-button :disabled="!selectedRole" type="is-warning" style="width:100px; margin-left:5px;" @click="openModel = true, cloneRole = true">Clone</b-button>
                </template>

                <template v-if="isSuperAdmin && selectedRole">
                    <b-button type="is-danger" style="width:100px; margin-left:5px;" @click="achiveRestore('archive')" v-if="!selectedRole.archived_at">Archive</b-button>
                    <b-button type="is-dark" style="width:100px; margin-left:5px;" @click="achiveRestore('restore')" v-else>Restore</b-button>
                </template>

                <b-modal :active="openModel" has-modal-card trap-focus aria-role="dialog" aria-modal>
                    <div class="modal-card" style="min-width:500px;">
                        <header class="modal-card-head">
                            <p class="modal-card-title">{{ cloneRole ? 'Clone Role' : 'Create Role' }}</p>
                        </header>
                        <section class="modal-card-body">
                            <b-field label="Role Name">
                                <b-input type="text" v-model="role.name"></b-input>
                            </b-field>
                        </section>
                        <footer class="modal-card-foot">
                            <button class="button" type="button" @click="openModel = false">Close</button>
                            <button class="button is-info" type="button" @click="saveRole">Save</button>
                        </footer>
                    </div>
                </b-modal>
            </div>
        </b-field>
        <b-table 
        	:data="filteredPermissions" 
        	:columns="columns" 
        	:sticky-header="true"
        	:height="'75vh !important'"
        	:is-row-checkable="(row) => (isSuperAdmin || hasThisRole) && selectedRole && (isSuperAdmin || !isSystem(row))"
            :checked-rows.sync="checkedRows"
            :loading="loading"
        	checkable
            @check="onTableCheck"
        >
            <template slot-scope="props">
                <b-table-column field="name" style="width:40%;">
                    {{ props.row.name }}
                    <template v-if="isSuperAdmin">
  
                        <button 
                        :class="'button is-small system-action ' + (isSystem(props.row) ? ' is-info' : '')"
                        @click="toggleTag(props.row, $event)">
                            SYSTEM
                        </button>
                        

                    </template>
                    <template v-else>
                        <button v-if="isSystem(props.row)" class="button is-small system-action is-danger" title="This permission is managed by the system">
                            SYSTEM
                        </button>
                    </template>
                </b-table-column>
                <b-table-column field="notes">
                    {{ props.row.notes }}
                </b-table-column>
            </template>
        </b-table>
	</section>
</template>
<script>
import { RoleService } from "@/services/role.service";
import { BaseService } from "@/services/base.service";
import { PermissionService } from "@/services/permission.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import { systemTagMixin } from '@/mixins/systemTagMixin';
import ModalConfirm from "@/components/partials/ModalConfirm";

export default {
	props: [ 'organization' ],
    mixins: [ systemTagMixin ],
    components: {
        ModalConfirm,
    },
    data: () => ({
        role: {
            name: null,
            // type: null,
            managed_by_firm_id: null,
        },
        openModel: false,
        cloneRole: false,
        doesHaveRole: false,
        loading: false,
    	selectedRole: null,
    	allRoles: [],
    	allPermissions: [],
        checkedRows: [],
        checkedRowsPrev: [],
        columns: [
            {
                field: 'name',
                label: 'Check All',
            },
            {
                field: 'notes',
                label: 'Notes'
            },
        ],
        rolePreviousValue: {},
        saveTrigger: false,
        openConfirm: true,
        modalConfirm: {
            title: "",
            message: "",
            onConfirm: null,
            onCancel: null
        }
    }),
    computed: {
        canCreateRole() {
            return (this.isSuperAdmin || this.isAdmin) && this.canManageRoles;
        },
        isSuperAdmin() {
            return this.$store.getters["Auth/hasRole"]('superadmin');
        },
        isAdmin() {
            return this.$store.getters["Auth/hasRole"]('admin');
        },
        canManageRoles() {
            return this.$store.getters["Auth/hasPermission"]("can manage roles");
        },
        roleDropdown() {
        	// if (this.isSuperAdmin) {
        	// 	return this.allRoles.filter(element => {
         //            if (element.type) {
         //                return element.type.toUpperCase().includes('[SYSTEM][ROLE]');
         //            }   
         //            return false;
         //        });
        	// } else {
                let roles = this.allRoles.filter(element => {
                    if (element.name.toUpperCase() == 'SUPERADMIN' && !this.isSuperAdmin) {
                        return false;
                    }
                    // let managed = element.managed_by_firm_id == this.organization.id;
                    let managed = false;
                    if (this.organization.managed_by) {
                        managed = element.managed_by_firm_id == this.organization.managed_by;
                    } else {
                        managed = element.managed_by_firm_id == this.organization.id;
                    }
                    let tag = false;
                    if (element.tags.length) {
                        tag = element.tags.find(tag => tag.type.toUpperCase() == '[SYSTEM]');
                    } 
                    return managed || tag;
                });
                return roles.filter(element => {
                    return element.type && element.type.toUpperCase().includes('[SYSTEM][ROLE]')
                });
        		// return roles.filter(element => element.type.toUpperCase().includes('[SYSTEM][ROLE]'));
        	// }
        },
        hasThisRole() {
            if (this.selectedRole) {
                return this.selectedRole.managed_by_firm_id == this.organization.id;
            }
            return false;
        },
        filteredPermissions() {
            // return this.allPermissions;
            if (this.isSuperAdmin) {
                return this.allPermissions;
            }else{
                let permissionIds = this.nativeData.filter(element => {
                    let x = true;
                    if (element.tags.length) {
                        let tag = element.tags.find(element => element.type == '[SYSTEM]' && element.name.toUpperCase() == 'SYSTEM');
                        x = tag && tag.pivot.archived_at != null;
                    }
                    return x;
                }).map(element => element.id);
                if (permissionIds.length) {
                    return this.allPermissions.filter(element => {
                        return permissionIds.includes(parseInt(element.id));
                    });
                }
            }
        }
    },
    watch: {
        selectedRole(role) {
        	if (role) {
                this.checkedRows = [];
                this.checkedRowsPrev = [];
	        	this.findRole(role);
        	}
            this.saveTrigger = false;
        },
        organization() {
        	this.selectedRole = null;
            this.checkedRows = [];
            this.checkedRowsPrev = [];
            this.role.managed_by_firm_id = this.organization.id;
        },
        checkedRows: {
            handler(value, previousValue) {
                // if (this.saveTrigger && this.openConfirm) {
                //     this.confirm(value, previousValue);
                // }
                // this.openConfirm = true;
            },
            deep: true
        }
    },
    methods: {
        achiveRestore(type) {
            let data = {
                type: type,
                model: 'Role',
                column: 'id',
                ids: [this.selectedRole.id]
            }
            BaseService.achiveRestore(data).then(response => {
                this.getRoles(this.selectedRole)
                this.$buefy.toast.open({
                  message: "Success",
                  type: "is-success",
                  position: "is-top-right"
                });       
            })
        },
        systemRole(role) {
            return role.tags.filter(element => element.type.toUpperCase() == '[SYSTEM]').length;
        },
        confirm(value, previousValue) {
            let message = '';
            if (previousValue.length > value.length) {
                message = 'Do you want to remove this permission from all users that currently have this role?';
            } else {
                message = 'Do you want to assign this permission to all users that currently have this role?';
            }

            if (this.selectedRole.has_users) {
                this.$buefy.dialog.confirm({
                    title: "Confirm",
                    message: message,
                    confirmText: "Confirm",
                    type: "is-danger",
                    hasIcon: true,
                    onConfirm: () => {
                        this.syncPermissions();
                    },
                    onCancel: () => {
                        this.checkedRows = previousValue;
                        this.openConfirm = false;
                    }
                });
            } else {
                this.syncPermissions();
            }

        },
    	async getRoles(autoSelect = false) {
            await RoleService.getTags().then(response => {
                this.allRoles = response;
                if (autoSelect) {
                    this.$nextTick(() => {
                        this.selectedRole = this.allRoles.find(element => element.id == autoSelect.id);
                    });
                }
            });
    	},
    	async getPermissions() {
            await PermissionService.all({ type:'user' }).then(response => {
                this.allPermissions = JsonDenormalizer.denormalize(response);
            });
    	},
        async getTags() {
            await PermissionService.getTags().then(response => {
                this.nativeData = response;
            });
        },
    	async findRole(role) {
            this.loading = true;
            await RoleService.find(role.id, { includes: 'permissions' }).then(response => {
                let role = JsonDenormalizer.denormalize(response);
                if (role.permissions.length) {
                	let permissionIds = role.permissions.map(element => element.id);
                	let x = this.allPermissions.filter(element => permissionIds.includes(element.id));
                    this.checkedRows = x;
                    this.checkedRowsPrev = x;
                }
                this.$nextTick(() => {
                    this.saveTrigger = true;
                });
                // this.checkedRows = role.permissions.length ? role.permissions : [] ;
            });
            this.loading = false;
    	},
        async toggleTag(row, event) {
            await PermissionService.toggleTag({id: row.id}).then(response => {
                this.$buefy.toast.open({
                  message: "Success",
                  type: "is-success",
                  position: "is-top-right"
                });       
            });
            event.target.classList.toggle('is-info')
        },
        async saveRole() {
            let data = this.role;
            if (this.cloneRole === true) {
                data.clone_role = this.selectedRole.id;
            }
            await RoleService.create(data).then(response => {
                this.getRoles(JsonDenormalizer.denormalize(response));
                this.$buefy.toast.open({
                  message: "New Role Created",
                  type: "is-success",
                  position: "is-top-right"
                }); 
                this.openModel = false;
                this.cloneRole = false;
                this.role.name = null;
                this.$emit('refetchRoles');
                // this.role.type               = null;
                // this.role.managed_by_firm_id = null;
            });
        },
        async syncPermissions() {
            this.loading = true;
            const data = {
                permission_ids: this.checkedRows.map(element => element.id)
            };
            await RoleService.syncPermissions(this.selectedRole.id, data).then(response => {
                this.$buefy.toast.open({
                  message: "Role permission updated",
                  type: "is-success",
                  position: "is-top-right"
                }); 
                this.$emit('refetchRoles');
            });
            this.loading = false;
        },
        async attachPermissions(permissionIds, syncToRoleUsers = false) {
            try {
                this.loading = true;
                
                await RoleService.attachPermissions(
                    this.selectedRole.id,
                    {
                        permission_ids: permissionIds,
                        sync_to_role_users: syncToRoleUsers ? 1 : 0
                    }
                );

                this.$emit("refetchRoles");
            } catch (err) {
                console.error(err);
                throw err;
            } finally {
                this.loading = false;
            }
        },
        async detachPermissions(permissionIds, syncToRoleUsers) {
            try {
                this.loading = true;
                
                await RoleService.detachPermissions(
                    this.selectedRole.id,
                    {
                        permission_ids: permissionIds,
                        sync_to_role_users: syncToRoleUsers ? 1 : 0
                    }
                );

                this.$emit("refetchRoles");
            } catch (err) {
                console.error(err);
                throw err;
            } finally {
                this.loading = false;
            }
        },
        onTableCheck(checkedRows, checkedRow) {
            // Previously checked rows
            this.checkedRowsPrev = this.checkedRows;
            // To attach or detach
            const attach = checkedRows.length > this.checkedRows.length;
            // Get permission ids
            // No checkedRow means check all
            let permissionIds = [];

            if ( ! checkedRow) {
                const source = attach ? checkedRows : this.checkedRows;
                permissionIds = source.map(permission => permission.id);
            } else {
                permissionIds = [checkedRow.id];
            }

            this.modalConfirm.title = `${attach ? 'Attach' : 'Detach'} Permission`;
            this.modalConfirm.message = `${attach ? 'Attach' : 'Detach'} this permission to all users with this role?`;
            
            if (attach) {
                this.modalConfirm.onConfirm = () => this.attachPermissions(permissionIds, true);
                this.modalConfirm.onCancel = () => this.attachPermissions(permissionIds);
            } else {
                this.modalConfirm.onConfirm = () => this.detachPermissions(permissionIds, true);
                this.modalConfirm.onCancel = () => this.detachPermissions(permissionIds);
            }

            this.$refs.modalConfirm.open();

            // this.$buefy.dialog.confirm({
            //     title: `${attach ? 'Attach' : 'Detach'} Permission`,
            //     message: `${attach ? 'Attach' : 'Detach'} this permission to all users with this role?`,
            //     confirmText: "YES",
            //     cancelText: "NO",
            //     type: "is-danger",
            //     hasIcon: true,
            //     onConfirm: () => {
            //         if (attach) {
            //             this.attachPermissions(permissionIds, true);
            //         } else {
            //             this.detachPermissions(permissionIds, true);
            //         }
            //     },
            //     onCancel: (cancelledBy) => {
            //         if (cancelledBy === "button") {
            //             if (attach) {
            //                 this.attachPermissions(permissionIds);
            //             } else {
            //                 this.detachPermissions(permissionIds);
            //             }
            //         } else {
            //             // Revert back to previous checked rows
            //             this.checkedRows = checkedRowsPrev;
            //         }
            //     }
            // });
        },
        onModalConfirmClose() {
            this.checkedRows = this.checkedRowsPrev;
        },
    },
    mounted() {
    	this.getRoles();
    	this.getPermissions();
        this.getTags();
        this.role.managed_by_firm_id = this.organization.id;
    }
};
</script>

<style scoped>
    .system-action {
        float:right; 
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/organizationRoles.vue